import { openURL } from 'expo-linking'
import { useState, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { env } from '@/src/config/env'
import { Button } from '@/src/elements/button/default'
import { useCommunityJoinSteps } from '@/src/features/community/ui/hooks/useCommunityJoinSteps'
import { useFraternityOnboardingMutation } from '@/src/features/fraternity/queries/useFraternityOnboardingMutation'
import { FraternityOnboardingWrapper } from '@/src/features/fraternity/ui/components/FraternityOnboardingWrapper'
import { ICON } from '@/src/general/enums/icons'

const leadUrl = env.EXPO_PUBLIC_VIRTUS_FRATERNITY_LEAD_URL

type TFraternityLeadScreenProps = TIdSlugParam & TSearchParamsParam

export const FraternityLeadScreen = ({ idSlug, searchParams }: TFraternityLeadScreenProps): ReactNode => {
  const [hasAskedLead, setHasAskedLead] = useState(false)

  const joinSteps = useCommunityJoinSteps({ idSlug, searchParams, stepName: 'lead' })
  const { goToNextStep } = joinSteps
  const { mutateAsync, isPending: isSaving } = useFraternityOnboardingMutation()

  const handleChoice = async (has_asked_lead: boolean) => {
    setHasAskedLead(true)
    await mutateAsync({ has_asked_lead })
    goToNextStep()
  }

  return (
    <FraternityOnboardingWrapper
      joinSteps={joinSteps}
      currentStep="lead"
      title={<FormattedMessage id="fraternity.lead.title" />}
      subtitle={<FormattedMessage id="fraternity.lead.description" />}
      footer={
        <View className="gap-2">
          <Button
            colors="primary"
            variant="faded"
            fullWidth
            isLoading={isSaving && !hasAskedLead}
            onPress={() => handleChoice(false)}
          >
            <FormattedMessage id="fraternity.lead.decline" />
          </Button>
          <Button
            colors="primary"
            variant="solid"
            fullWidth
            isLoading={isSaving && hasAskedLead}
            onPress={() => handleChoice(true)}
          >
            <FormattedMessage id="fraternity.lead.accept" />
          </Button>
        </View>
      }
    >
      {leadUrl ? (
        <Button
          variant="light"
          colors="primary"
          startIcon={ICON.INFO_CIRCLE}
          onPress={() => openURL(leadUrl)}
          textClassName="mb-px"
        >
          <FormattedMessage id="fraternity.lead.learn-more" />
        </Button>
      ) : null}
    </FraternityOnboardingWrapper>
  )
}
